import { render } from "./WebsocketClosedModal.vue?vue&type=template&id=f0f3452a"
import script from "./WebsocketClosedModal.vue?vue&type=script&lang=js"
export * from "./WebsocketClosedModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__